"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _reactSortableHoc = require("react-sortable-hoc");

var _Trash = _interopRequireDefault(require("@insided/shared/icons/Trash"));

var _ExternalLink = _interopRequireDefault(require("@insided/shared/icons/ExternalLink"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _DragHandle = _interopRequireDefault(require("../DragHandle"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomDiv = function CustomDiv(props) {
  var className = props.className,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return (0, _preact.h)("div", (0, _extends2.default)({}, otherProps, {
    className: "dropdown-children-list__item ".concat(className !== null && className !== void 0 ? className : '')
  }));
};

var SortableItem = (0, _reactSortableHoc.SortableElement)(CustomDiv);
var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
  var children = _ref.children;
  return (0, _preact.h)("div", {
    className: "dropdown-children-list__items"
  }, children);
});

var DropdownColumnBody = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropdownColumnBody, _Component);

  var _super = _createSuper(DropdownColumnBody);

  function DropdownColumnBody() {
    var _this;

    (0, _classCallCheck2.default)(this, DropdownColumnBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSortEnd", function (_ref2) {
      var oldIndex = _ref2.oldIndex,
          newIndex = _ref2.newIndex;
      var _this$props = _this.props,
          childrenItems = _this$props.childrenItems,
          onChange = _this$props.onChange;
      onChange((0, _reactSortableHoc.arrayMove)(childrenItems, oldIndex, newIndex));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDeleteChild", function (index) {
      var _this$props2 = _this.props,
          childrenItems = _this$props2.childrenItems,
          onChange = _this$props2.onChange;
      var newChildren = childrenItems.filter(function (_, i) {
        return i !== index;
      });
      onChange(newChildren);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAddChild", function () {
      var _this$props3 = _this.props,
          childrenItems = _this$props3.childrenItems,
          onChange = _this$props3.onChange,
          onSelect = _this$props3.onSelect;
      var newChild = {
        id: Date.now(),
        title: 'Untitled',
        url: '',
        external: false,
        children: []
      };
      var newChildren = [].concat((0, _toConsumableArray2.default)(childrenItems), [newChild]);
      onChange(newChildren);
      onSelect(newChild.id.toString());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderChildItem", function (child, index) {
      var _child$title, _child$children$lengt, _child$children;

      var _this$props4 = _this.props,
          selectedChildId = _this$props4.selectedChildId,
          onSelect = _this$props4.onSelect;
      var childId = child.id.toString();
      var isSelected = selectedChildId === childId;
      var hasChildren = child.children && child.children.length > 0;
      return (0, _preact.h)(SortableItem, {
        index: index,
        key: childId,
        onClick: function onClick() {
          return onSelect(childId);
        },
        className: (0, _classnames.default)('dropdown-children-list__item-content', {
          'dropdown-children-list__item-content--selected': isSelected
        })
      }, (0, _preact.h)(_DragHandle.default, null), (0, _preact.h)("div", {
        className: "dropdown-children-list__item-info",
        role: "button",
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            onSelect(childId);
          }
        }
      }, (0, _preact.h)("span", {
        className: "dropdown-children-list__item-title"
      }, (_child$title = child.title) !== null && _child$title !== void 0 ? _child$title : 'Untitled'), child.url && (0, _preact.h)("span", {
        className: "dropdown-children-list__item-url"
      }, child.url), child.external && (0, _preact.h)(_ExternalLink.default, {
        width: 10,
        height: 10
      }), hasChildren && (0, _preact.h)("span", {
        className: "dropdown-children-list__item-children-count"
      }, "(", (_child$children$lengt = (_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.length) !== null && _child$children$lengt !== void 0 ? _child$children$lengt : 0, ")")), (0, _preact.h)("div", {
        className: "dropdown-children-list__item-actions"
      }, (0, _preact.h)("button", {
        className: "dropdown-children-list__item-action dropdown-children-list__item-action--delete",
        onClick: function onClick() {
          return _this.onDeleteChild(index);
        },
        title: "Delete"
      }, (0, _preact.h)(_Trash.default, {
        width: 12,
        height: 12
      }))));
    });
    return _this;
  }

  (0, _createClass2.default)(DropdownColumnBody, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var childrenItems = this.props.childrenItems;
      return (0, _preact.h)("div", {
        className: "dropdown-column__children"
      }, (0, _preact.h)("div", {
        className: "dropdown-section"
      }, (0, _preact.h)("div", {
        className: "dropdown-section__header"
      }, (0, _preact.h)("h4", {
        className: "dropdown-section__title"
      }, "Children")), (0, _preact.h)("div", {
        className: "dropdown-section__body"
      }, (0, _preact.h)("div", {
        className: "dropdown-children-list"
      }, childrenItems.length === 0 && (0, _preact.h)("div", {
        className: "dropdown-children-list__empty"
      }, "No Children Items"), childrenItems.length > 0 && (0, _preact.h)(SortableList, {
        onSortEnd: this.onSortEnd,
        useDragHandle: true
      }, childrenItems.map(function (child, index) {
        return _this2.renderChildItem(child, index);
      })), (0, _preact.h)(_buttonControl.default, {
        title: "Add Child",
        variant: "secondary",
        size: "small",
        onClick: this.onAddChild,
        newStyle: true
      })))));
    }
  }]);
  return DropdownColumnBody;
}(_preact.Component);

exports.default = DropdownColumnBody;